import Redactor from './redactor.esm.min.js'

// Official plugin files call Redactor.addPlugin on the global.
window.Redactor = Redactor

export default Redactor
